import React, { Component } from 'react';

//componentes
import TercerTrimestre from './tercerTrimestre'

class Index extends Component {

    render(){
        return(
            <div>
                <TercerTrimestre />
            </div>
        );
    }

}
export default Index;